module.exports = __webpack_public_path__ + "static/media/blocZendy.ad02b682.jpg";